import { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import publicRoutes from "routes/route.public";
import authRoutes from "routes/route.auth";

import ErrorBoundary from "components/error/ErrorBoundary";
import MainLayout from "components/layouts/Layout/MainLayout";
import ClientLayout from "components/layouts/Layout/ClientLayout";
import NotFoundPage from "components/error/NotFoundPage";
import PrivateRoutes from "routes/PrivateRoutes";
import RequireRoutePermission from "routes/RequireRoutePermission";
import { FULL_MENU } from "components/layouts/Navbar/navbarConfig";
import { useAbility } from "configs/casl";
import { canAccessRequirement } from "utils/helpers/authorization";

const DefaultAuthRedirect: FC = () => {
  const ability = useAbility();

  for (const item of FULL_MENU) {
    if (item.children.length === 0) {
      if (item.link && canAccessRequirement(ability, item.required)) {
        return <Navigate to={item.link} replace />;
      }
      continue;
    }

    const firstChild = item.children.find((child) =>
      canAccessRequirement(ability, child.required),
    );

    if (firstChild) {
      return <Navigate to={firstChild.link} replace />;
    }
  }

  return <NotFoundPage />;
};

const App: FC = () => {
  return (
    <ErrorBoundary>
      <Routes>
        <Route element={<ClientLayout />}>
          {publicRoutes.map(({ path, element }) => {
            const Element: FC = element;
            return <Route key={path} path={path} element={<Element />} />;
          })}
        </Route>
        <Route element={<PrivateRoutes />}>
          <Route element={<MainLayout />}>
            <Route path="/" element={<DefaultAuthRedirect />} />
            {authRoutes.map(({ path, element, required }) => {
              const Element: FC = element;
              return (
                <Route
                  key={path}
                  path={path}
                  element={
                    <RequireRoutePermission required={required}>
                      <Element />
                    </RequireRoutePermission>
                  }
                />
              );
            })}
          </Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ErrorBoundary>
  );
};

export default App;
